class ConfigSingleton {
    constructor(initialData) {
        this.state = { ...initialData };
    }

    getConfig() {
        return this.state;
    }

    setConfig(config) {
        Object.entries(config).map(([key, value]) => {
            this.state[key] = value;
        });
    }
}
// added properties from .env file
const initialData = {
    REACT_APP_BASE_URL: 'https://correction.dev.finezza.in',
    REACT_APP_POSTHOG_PROJECT_TOKEN: '',
    REACT_APP_POSTHOG_HOST: ''
};

const configSingletonInstance = new ConfigSingleton(initialData);
export default configSingletonInstance;
